<template>
    <div class="vivo-batch-create-page-wrap">
        <div class="create_page_header" :style="{width: fixWidth}">
            <el-button type="text" icon="el-icon-back" :style="{fontSize: '14px'}" @click="cancelCreate" v-matomo="{behaviorCategory: 'vivo(批量创建)',  name: '批量创建('+getBehaviorName(curStep)+'-取消创建)' }">取消创建</el-button>
            <span class="text pl10 pr10 font14px">|</span>
            <span class="text pr10 font14px">批量创建</span>
            <el-button v-if="curStep>1" type="default" size="small" ghost class="action-btn" @click="toLastStep" v-matomo="{behaviorCategory: 'vivo(批量创建)',  name: '批量创建('+getBehaviorName(curStep)+'-返回上一步)' }">返回上一步</el-button>
            <el-button v-if="curStep<3" type="primary" size="small" ghost class="action-btn" :loading="nextStepLoading" @click="toNextStep" v-matomo="{behaviorCategory: 'vivo(批量创建)',  name: '批量创建('+getBehaviorName(curStep)+'-下一步)' }">下一步</el-button>
           
            <template v-if="curStep==3">
                <el-popover
                    placement="bottom"
                    title="以下内容存在问题，请检查后重试："
                    width="400"
                    trigger="manual"
                    v-model="popoverVisible">
                    <div class="tip-list " style="max-height: 500px;overflow-y: auto">
                        <div v-for="(item, index) in errorFormList" :key="index">
                            <div>{{ item.title }}</div>
                            <p class="pl20" v-for="(v, i) in item.list" :key="i">
                                {{i+1}}、{{v}}
                            </p>
                        </div>
                    <div class="btn tac mt20"><el-button @click="popoverVisible = !popoverVisible" type="primary" size="mini"><span>关闭</span></el-button></div>
                    </div>
                    <el-button slot="reference"  type="primary" size="small" ghost class="action-btn" :loading="previewLoading" @click="previewIdeaInfo" v-matomo="{behaviorCategory: 'vivo(批量创建)',  name: '批量创建('+getBehaviorName(curStep)+'-生成预览)' }">生成预览</el-button>
                </el-popover>
            </template>
            <template v-if="curStep==3">
                <el-popover
                        placement="bottom"
                        title=""
                        width="400"
                        trigger="click"
                        @show="handleIdeaShow"
                >
                        <div class="right-con">
                            <IdeaSpecsPreview 
                            :data="filesTables" 
                            :app-data="curAppData" 
                            :config="planUploadConfig" 
                            :target="formItem.target_account" 
                            :replace-name-status="formItem.replace_name_status" 
                            :plan-id="formItem.plan_id" 
                            :task-id="taskId" 
                            ref="ideaSpecsPreview" 
                            @preview="updatePreviewLoading" 
                            @previewDom="previewIdeaDom"/>
                        </div>
                        <!-- <el-button  type="primary" size="small" ghost class="action-btn" slot="reference" plain  >查看计划规格</el-button> -->
                </el-popover>
            </template>

            <el-button v-if="curStep==4" type="primary" size="small" ghost class="action-btn" :loading="submitLoading" @click="handleSubmit">提交</el-button>
        </div>
        <div class="create_page_body">
            <div class="step-bar mt20">
                <el-steps :active="curStep" process-status="process" align-center>
                    <el-step title="调用计划"></el-step>
                    <el-step title="规则配置"></el-step>
                    <el-step title="上传创意"></el-step>
                    <el-step title="生成预览"></el-step>
                </el-steps>
            </div>

            <div class="form-wrap ml60">
                <div class="step-form-wrap">
                    <el-form ref="form1" class="form1" v-show="curStep==1" :model="formItem" :rules="form1Rules" label-width="200px">
                        <h3 class="title-group">1、选择调用计划</h3>
                        <el-form-item prop="account_id" label="选择账户：" class="label-required">
                            <ESelect v-model="formItem.account_id" filterable remote
                                       placeholder="请选择要调用计划的账户，支持名称或用户名关键字搜索账户"
                                       :remote-method="getAccountList"
                                       :loading="accountLoading"
                                       popper-class="select-option-long-text-wrap"
                                       @change="changeAccount"
                                       clearable
                                       style="width: 400px;">
                                <el-option
                                    v-for="item in accountList"
                                    :key="item.account_id"
                                    :label="item.account_name+'-'+item.user_name+'-'+item.account_id"
                                    :value="item.account_id">
                                    {{item.account_name}}-{{item.user_name}}({{item.account_id}})
                                </el-option>
                            </ESelect>
                        </el-form-item>
                        <el-form-item prop="plan_id" label="选择计划：" class="label-required">
                            <div>
                                <ESelect v-model="formItem.plan_id" filterable
                                           placeholder="请选择要调用的计划，支持名称或ID关键字搜索计划"
                                           @change="changePlan"
                                           clearable
                                           popper-class="select-option-long-text-wrap"
                                           style="width: 400px;">
                                    <el-option
                                        v-for="item in planList"
                                        :key="item.plan_id"
                                        :label="item.plan_name+'('+item.plan_id+')'"
                                        :value="item.plan_id">
                                        {{item.plan_name}}（{{item.plan_id}}）
                                    </el-option>
                                </ESelect>
                                <DelayButton :delay="120" :loading="updatePlanLoading" :disabled="!formItem.account_id" :click-fn="updatePlanList" text="更新计划" class="ml20"/>
                                <span class="text-color-gray ml20">请勿频繁点击，以免造成接口调用次数超限</span>
                            </div>
                            <p class="text-color-gray mt10 font12px">符合以下条件的计划目前不可选：</p>
                            <p class="text-color-gray ml6 font12px">
                                1、推广目标非应用、非快应用；2、计划类型非信息流、非联盟、非智能投放（不包含信息流搜索广告）；3、计划下存在广告组/广告/创意为空；4、计划下包含或只有无素材的无图创意；5、包含组图；6、计划/广告组/广告名称超过100字；7、包含多个产品；
                            </p>
                        </el-form-item>
                        <el-form-item prop="is_check_plan">
                            <el-button v-if="!isCheckedPlanInfo" :disabled="!formItem.account_id||!formItem.plan_id" :loading="checkPlanLoading" @click="checkPlanInfo" style="width: 120px;" type="primary" size="mini" ghost >核实计划信息</el-button>
                            <el-button v-else type="primary" size="mini" style="width: 120px;">已核实</el-button>
                        </el-form-item>


                        <h3 class="title-group">2、选择目标账户</h3>
                        <el-form-item prop="target_account" label="目标账户：" class="label-required">
                            <ESelect ref="targetAccountSelect" :value="formItem.target_account" filterable remote
                                       multiple
                                       placeholder="请选择目标账户"
                                       @change="changeTargetAccount"
                                       :disabled="hasGroupTargetId||!isCheckedPlanInfo"
                                       :remote-method="getTargetAccountList"
                                       :loading="targetAccountLoading"
                                       style="width: 400px;">
                                <el-option
                                    v-for="item in targetAccountList"
                                    :key="item.account_id"
                                    :disabled="item.disabled"
                                    :label="item.account_name+'-'+item.user_name+'-'+item.account_id"
                                    :value="item.account_id">
                                    {{item.account_name}}-{{item.user_name}}({{item.account_id}})
                                </el-option>
                            </ESelect>
                            <div class="text-color-gray mt10 font12px">
                                <p>批量创建的计划创建在选择的所有目标账户内，内容完全一致。有以下两点需要注意：</p>
                                <p class="ml6">1、无法跨账户使用的内容请勿选择，比如人群包。</p>
                                <p class="ml6">2、跨账户创建请确保账户内权限一致，否则会创建失败。</p>
                            </div>
                        </el-form-item>
                    </el-form>
                    <el-form ref="form2" v-show="curStep==2" :model="formItem" :rules="form2Rules" label-width="200px">
                        <h3 class="title-group">3、基础配置</h3>
                        <el-form-item prop="plan_status" label="新计划状态：" class="label-required">
                            <el-radio-group v-model="formItem.plan_status">
                                <el-radio label="1">关闭</el-radio>
                                <el-radio label="0">开启</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item prop="app_id" label="投放产品：" class="label-required">
                            <ESelect
                                class="input-width"
                                ref="productRef"
                                :value="formItem.app_id"
                                :loading="appLoading"
                                multiple
                                reserve-keyword
                                filterable
                                :filter-method="SearchFilter"
                                @visible-change="handleVisible"
                                @change="handleChange"
                                clearable
                                placeholder="请选择要投放的产品，可多选">
                                <div :style="{cursor: 'pointer', paddingLeft: '20px', marginBottom: '6px', color: '#409EFF'}">
                                    <span :style="{display: 'inline-block'}"  @click="handleAllSelect('all')">全选</span>
                                    <span :style="{display: 'inline-block', marginLeft: '10px'}" @click="handleAllSelect('cancel')">取消全选</span>
                                </div>
                                <el-option
                                    v-for="item in appList"
                                    :key="item.package_name"
                                    :label="item.app_name+'（ID:'+item.app_id+'，包名:'+item.package_name+'）'"
                                    :value="item.package_name">
                                    {{item.app_name}}（ID:{{item.app_id}}，包名：{{item.package_name}}）
                                </el-option>
                            </ESelect>
                            <el-button
                                style="margin-left:15px"
                                type="primary"
                                plain
                                @click="handleBatchAppClick"
                            >
                                批量录入
                            </el-button>
                            <div class="text-color-gray font12px mt10">
                                <p>可选产品：选择的目标账户对应的客户已绑定的产品（若无对应产品请联系组长进行产品绑定）</p>
                            </div>
                        </el-form-item>
                        <el-form-item prop="qualificationStatus" label="" class="label-required">
                            <el-button v-if="!formItem.qualificationStatus" :disabled="!formItem.app_id || formItem.app_id.length === 0"  type="primary" plain @click="getQualification" :loading="qualificationLoading">投放资质认证</el-button> 
                            <el-button v-else type="success">投放资质认证<i class="el-icon-check el-icon--right"></i></el-button>
                            <!-- success -->
                        </el-form-item>
                        <el-form-item label="链接配置：" prop="linkConfigList"> 
                            <template v-if="linkConfigList.length">
                                <LinkConfig ref="linkConfigRef" :list="linkConfigList" :deeplinkValidConfig="deeplinkValidConfig"/> 
                            </template>
                            <template v-else>
                                <span class="font12px">选择产品并且进行资质认证后可配置</span>
                            </template>
                        </el-form-item>
                        <el-form-item label="命名：" class="label-required">
                            <p class="mt8 font12px">1、防止重名，在名称尾缀增加当日时间+任务序号+顺序号（示例：捕鱼-信息流-2310910361-1-1、捕鱼-信息流-23100910361-1-2、捕鱼-信息流-23100910361-1-3）</p>
                            <p class="font12px mt6 mb6">2、替换产品名称：
                                <el-switch v-model="formItem.replace_name_status" active-value="1" inactive-value="0" class="mini-switch"></el-switch>
                            </p>
                            <p class="font12px pl20">若开启，则将原计划、组、广告名称中的产品名称修改为新的产品名称 (取其项目名称)，修改规则如下:</p>
                            <p class="font12px pl40">a）名称中取第一个“-”，将第一个“-”前边的文字换成新的项目名称;</p>
                            <p class="font12px pl40">b）未检测到“-”时，在原名称基础上最前边增加“项目名称-”</p>
                            <p class="font12px pl20 text-color-primary">使用Tips：需要修改产品的模板计划，进行统一规范命名，将产品名称填写在最开始，后边拼接“-”如[捕鱼大作战-联盟-自定义xxx】</p>
                        </el-form-item>
                        <el-form-item label="流量优选开关：" class="label-required">
                            <p class="mt4 font12px">新创建的广告默认全部【关闭】</p>
                        </el-form-item>
                        <!--<el-form-item prop="skip_ocpx_stage" label="跳过一阶段：" class="label-required">-->
                        <!--<el-radio-group v-model="formItem.skip_ocpx_stage">-->
                        <!--<el-radio label="0">关闭</el-radio>-->
                        <!--<el-radio label="1">开启</el-radio>-->
                        <!--</el-radio-group>-->
                        <!--</el-form-item>-->
                        <el-form-item prop="skip_ocpx_stage" label="投放日期：" class="label-required">
                            <div class="mb10">
                                <el-button-group>
                                    <el-button @click="changeDateType('1')" :type="dateType=='1'?'primary':'default'" class="tab-nav-btn">长期投放</el-button>
                                    <el-button @click="changeDateType('2')" :type="dateType=='2'?'primary':'default'" class="tab-nav-btn">指定开始和结束日期</el-button>
                                </el-button-group>
                            </div>
                            <div v-if="dateType=='1'">
                                <span class="mr10">开始日期: </span>
                                <el-date-picker type="date" v-model="range" :picker-options="dateOptions" :clearable="false" value-format="yyyy-MM-dd" key="range" placeholder="选择开始日期" style="width: 238px"></el-date-picker>
                                <span class="text-color-error font12px ml20" v-if="curHour>=23&&groupStartDate==todayStr">距离第二天不足一小时，请确认开始日期，以免创建失败！</span>
                            </div>
                            <div v-if="dateType=='2'">
                                <el-date-picker type="daterange" v-model="range1" :picker-options="dateOptions" :clearable="false" value-format="yyyy-MM-dd" key="range1" placeholder="选择开始和结束日期" style="width: 300px"></el-date-picker>
                                <span class="text-color-error font12px ml20" v-if="curHour>=23&&groupStartDate==todayStr">距离第二天不足一小时，请确认开始日期，以免创建失败！</span>
                            </div>
                        </el-form-item>

                        <h4 class="title-group">4、批量规则</h4>
                        <el-form-item prop="batch_rules" label="创意上传规则：" class="label-required">
                            <el-radio-group v-model="formItem.batch_rules">
                                <el-radio-button label="1" v-if="pageFuncNames.includes('create_config_1')">分广告组/场景/创意规格上传</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>

                    <el-form ref="form3" v-show="curStep==3" label-width="120px">
                        <!--    -->
                        <template v-if="isAimedia">
                            <!-- 智能投放的素材 -->
                             <AiLaunchIdea 
                                :is-show="curStep==3"
                                :app_list="curAppData"
                                :plan-id="formItem.plan_id"
                                :task-id="taskId"
                                ref="aiLaunchIdeaRef"
                            />
                        </template>
                        <template v-else>
                            <UploadIdea
                                :is-show="curStep==3"
                                :app_list="curAppData"
                                :plan-id="formItem.plan_id"
                                :task-id="taskId"
                                ref="UploadIdea"
                            />
                        </template>
                       
                       
                    </el-form>

                    <div v-show="curStep==4">
                        <div class="ml100">
                            <IdeaResult ref="ideaList" :is-aimedia="isAimedia"  :task-id="taskId" :form-item="formItem" :date-type="dateType" :app-data="curAppData" :range="range" :range1="range1"/>
                        </div>
                    </div>

                </div>
                <div class="button-groups mt60">
                    <!--<el-button type="default" size="small" ghost class="action-btn" @click="cancelCreate">取消创建</el-button>-->
                    <!--<el-button v-if="curStep>1" type="default" size="small" ghost class="action-btn" @click="toLastStep">上一步</el-button>-->
                    <!--<el-button v-if="curStep<3" type="primary" size="small" ghost class="action-btn" :loading="nextStepLoading" @click="toNextStep">下一步</el-button>-->
                    <!--<el-button v-if="curStep==3" type="primary" size="small" ghost class="action-btn" :loading="previewLoading" @click="previewIdeaInfo">生成预览</el-button>-->
                    <!--<el-button v-if="curStep==4" type="primary" size="small" ghost class="action-btn" :loading="submitLoading" @click="handleSubmit">提交</el-button>-->
                </div>
            </div>

            <CheckPlanModal :plan-id="formItem.plan_id" :account-id="formItem.account_id" @confirm="confirmPlanInfo" ref="checkPlanModal" @update="checkPlanLoading=false" />
        </div>
  </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import CheckPlanModal from '../modal/checkPlanModal';
    import AdGroupItem from '../components/adGroupItem';
    import MaterialItem from '../components/materialItem';
    import DelayButton from '../components/delayButton';
    import IdeaSpecsPreview from '../components/ideaSpecsPreview';
    import IdeaResult from '../components/ideaResult';
    import { batchEnterModal, tipModal } from '../modal/index';
    import API from '@/api/marketManage/vivoBatch';
    import utils from '@/libs/utils.js';
    import dayjs from 'dayjs';
    import UploadIdea from '../components/uploadIdea'
    import {uniq, remove} from "lodash";
    import LinkConfig from '../components/linkConfig'
    import AiLaunchIdea from '../components/aiLaunchIdea'
    export default {
        name: "ConfigPage",
        props:{
            pageFuncNames:Array,
        },
        components:{
            CheckPlanModal,
            AdGroupItem,
            MaterialItem,
            DelayButton,
            IdeaSpecsPreview,
            IdeaResult,
            UploadIdea,
            LinkConfig,
            AiLaunchIdea
        },
        data(){
            let todayStr = dayjs().format('YYYY-MM-DD');
            
            const validatePlan = (rule, value, callback) => {
                if (!this.isCheckedPlanInfo) {
                    callback(new Error('请核实计划信息'));
                } else {
                    callback();
                }
            };
            const validateQualificationStatus = (rule, value, callback) => {
                if (!this.formItem.qualificationStatus) {
                    callback(new Error('请核实新增投放资质'));
                } else {
                    callback();
                }
            };
            const validateLinkConfigList = (rule, value, callback) => {
                if (this.linkConfigList.length === 0) {
                    callback(new Error('请核实计划配置链接'));
                } else {
                    callback();
                }
            };
            
            return {
                fixWidth: '1000px',
                curStep: 1,
                seeVisible: false,
                formItem:{
                    account_id:'',
                    plan_id:'',
                    target_account:[],
                    app_id:[],
                    plan_status:'1',
                    skip_ocpx_stage:'1',
                    general_switch:'0',
                    batch_rules:'',
                    idea_upload_config:'1',
                    replace_name_status:'1',
                    qualificationStatus: false,  //新增投放资质
                },
                appList:[
                   
                ],
                dateType:'1',
                step1Loading:false,
                accountLoading:false,
                updatePlanLoading:false,
                accountList:[],
                planList:[],
                targetAccountList:[],
                isCheckedPlanInfo:false,
                checkPlanLoading:false,
                hasGroupTargetId:false,
                targetAccountLoading:false,
                form1Rules:{
                    account_id:[
                        { required: true, message: '请选择账户', trigger: 'change' }
                    ],
                    plan_id:[
                        { required: true, message: '请选择计划' },
                    ],
                    is_check_plan:[
                        { validator: validatePlan },
                    ],
                    target_account:[
                        { type: 'array', required: true, message: '请选择目标账户', trigger: 'change' }
                    ],
                },
                form2Rules:{
                    batch_rules:[
                        { required: true, message: '创意上传规则不能为空' },
                    ],
                    app_id:[
                        { required: true, type:'array', message: '请选择投放产品', trigger: 'change' }
                    ],
                    qualificationStatus:[
                        { validator: validateQualificationStatus },
                    ],
                    linkConfigList: [
                        {  validator: validateLinkConfigList  , trigger: 'change' }
                    ],
                },
                range:todayStr,
                range1:[todayStr,todayStr],
                dateOptions:{
                    firstDayOfWeek: 1,
                    disabledDate (date) {
                        return date && date.valueOf() < Date.now() - 1000*60*60*24;
                    }
                },
                taskId:'',
                sourceAppId:'',         // 记录源appId
                planUploadConfig:[],        // 存储所有的上传规格
                activeGroupId:'',     // 当前激活的广告组
                activeDisplayId:'',     // 当前激活的展现形式
                activeNormId:'',      // 当前激活的创意规格
                filesTables:{},
                uploadStore:[],         // 缓存上传成功的素材
                submitLoading:false,
                uploadQueueCnt:0,
                fullscreenLoading: false,  //上传loading
                planNotifyTip:null,
                previewLoading:false,
                nextStepLoading:false,
                appLoading:false,
                checkMax: 50,
                appListCacheOptions:[], //appList 的缓存
                qualificationLoading: false,
                user_names:[],  //名字收集 认证使用
                isAimedia: false,//是否为智能投放
                linkConfigList: [],
                linkConfigData: [],//验证通过的数据
                deeplinkValidConfig: [],//deeplink开头验证
                errorFormList: [],//错误的提示数据
                popoverVisible: false,
            }
        },
        computed:{
            ...mapGetters(['sidebar']),
            activeGroup(){
                return this.planUploadConfig.find(item=>item.group_id == this.activeGroupId);
            },
            activeDisplayType(){
                let displayList = this.activeGroup?(this.activeGroup.display_list||[]):[];
                return displayList.find(item=>item.display_type == this.activeDisplayId);
            },
            activeNorm(){
                let normList = this.activeDisplayType?(this.activeDisplayType.norm_list||[]):[];
                return normList.find(item=>(item.norm_model+'-'+item.norm_id) == this.activeNormId);
            },
            groupOptions(){
                return this.planUploadConfig.map(item=>{
                    return {
                        group_id:item.group_id,
                        group_name:item.group_name,
                        total:item.total||0,
                    }
                })
            },
            displayOptions(){
                let actionGroup = this.planUploadConfig.find(item=>item.group_id == this.activeGroupId);
                if(!actionGroup) return [];
                let displayList = actionGroup.display_list||[];
                return displayList.map(item=>{
                    return {
                        display_type:item.display_type,
                        display_type_text:item.display_type_text,
                        total:item.total||0,
                    }
                })
            },
            normOptions(){
                let normList = this.activeDisplayType?(this.activeDisplayType.norm_list||[]):[];
                return normList.map(item=>{
                    return {
                        norm_id:item.norm_id,
                        norm_model:item.norm_model,
                        norm_model_text:item.norm_model_text,
                        total:item.total||0,
                    }
                })
            },
            fileConfigs(){
                return this.activeNorm?this.activeNorm.config||[]:[];
            },
            tableColumns(){
                let baseCol = {
                    id:'-1',
                    name:'index',
                    label:'序号',
                };
                let cols = this.fileConfigs.map(item=>{
                    let resolution = item.conf_resolution||'';
                    let [width,height] = resolution.split('*');
                    return {
                        id:item.conf_m_id,
                        name:item.value_name,
                        label:item.explicit_name,
                        size:item.conf_size,
                        conf_size_name:item.conf_size_name,
                        conf_format:item.conf_format,
                        material_type:item.material_type,
                        width:width,
                        height:height,
                        required:item.material_is_null=='0',
                    }
                });
                return [baseCol].concat(cols);
            },
            fileAccept(){
                let allFormats = this.fileConfigs.map(item=>item.conf_format).join('/').toLocaleLowerCase();
                let results = [];
                if(allFormats.includes('png')){
                    results.push("image/png");
                }
                if(allFormats.includes('jpeg')||allFormats.includes('jpg')){
                    results.push("image/jpeg");
                }
                if(allFormats.includes('gif')){
                    results.push("image/gif");
                }
                if(allFormats.includes('mp4')){
                    results.push("video/mp4");
                }
                return results.join(',');
            },
            uploadSign(){
                //  用来标记当前表格的id
                return this.activeGroupId+'-'+this.activeDisplayId+'-'+this.activeNormId;
            },
            isNeedTipLast(){
                let needTip = false;
                if(this.curStep == 1){
                    needTip = false;
                }
                if(this.curStep == 2&&this.formItem.plan_status!='1'||this.formItem.skip_ocpx_stage!='1'||this.dateType!='1'||(this.dateType=='1'&&!dayjs(this.range).isSame(dayjs(),'day'))){
                    needTip = true;
                }
                if(this.curStep == 3&&this.uploadStore.length>0){
                    needTip = true;
                }
                if(this.curStep == 4){
                    needTip = false;
                }
                return needTip;
            },
            curHour(){
                return dayjs().hour();
            },
            curAppData(){
                return this.formItem.app_id.map(app=>{
                    let actionApp = this.appListCacheOptions.find(item=>item.package_name==app);
                    return actionApp? {...actionApp} : null;
                }).filter(v=> !!v);
            },
            groupStartDate(){
                if(this.dateType=='1') return this.range;
                if(this.dateType=='2') return this.range1[0];
                return "";
            },
            todayStr(){
                return dayjs().format('YYYY-MM-DD');
            },
        },
        mounted(){
            this.getFixWidth();
            // this.toNextStep()
            window.addEventListener("resize", this.getFixWidth);
            window.onbeforeunload = function(){
                return "确定要离开吗？系统可能不会保存您所做的更改";
            }
        },
        watch:{
            sidebar: {
                handler(){
                    setTimeout(this.getFixWidth, 300)
                },
                deep:true,
            },
            'formItem.app_id': {
                handler(n, o){
                    if(n.length === 0 || n.length > o.length) {
                    this.formItem.qualificationStatus = false;
                    }
                },
                deep:true,
            }
        },
        methods:{
            getFixWidth(){
                let $createBody = document.querySelector('.create_page_body');
                if(!$createBody) return ;
                this.fixWidth = `${$createBody.clientWidth}px`;
            },
            resetForm(){
                this.curStep = 1;
                this.uploadStore = [];      // 清空上传的文件缓存；
                this.uploadQueueCnt = 0;    // 清空上传队列的数量
            },
            getBehaviorName(step){
                // console.log('getBehaviorName',this.curStep,step);
                if(step == 1) return '第一步';
                if(step == 2) return '第二步';
                if(step == 3) return '第三步';
                if(step == 4) return '生成预览';
            },
            getAccountList(query){
                if(!query) return this.accountList = [];
                this.accountLoading = true;
                API.getAccountList({
                    search:query,
                }).then(res=>{
                    let resList = res.data||[];
                    /* 数据量大时直接截取前100条 */
                    this.accountList = resList.slice(0,100);
                    this.accountLoading = false;
                },err=>{
                    console.log('getAccountList err',err);
                    this.accountList = [];
                    this.accountLoading = false;
                })
            },
            changeAccount(val){
                if(this.uploadStore.length>0){
                    this.resetStep2Data();
                    this.resetStep3Data();
                }
                if(!val){
                    this.planList = [];
                    this.formItem.plan_id = '';
                    this.isCheckedPlanInfo = false;
                    return false;
                }
                this.formItem.plan_id = '';
                this.isCheckedPlanInfo = false;
                this.formItem.target_account = [];
                this.getPlanList();
            },
            getPlanList(){
                if(!this.formItem.account_id) return this.planList = [];
                API.getPlanList({
                    account_id:this.formItem.account_id,
                }).then(res=>{
                    this.planList = res.data||[];
                },err=>{
                    console.log('getPlanList err',err);
                    this.planList = [];
                })
            },
            changePlan(){
                this.isCheckedPlanInfo = false;
                this.resetStep2Data();
                this.resetStep3Data();
            },
            updatePlanList(){
                if(!this.formItem.account_id) return this.$message.error('请先选择账户');
                this.planNotifyTip = this.$notify.success({
                    title: '请求成功',
                    message: '正在更新，请稍候…',
                    duration: 0
                });
                this.updatePlanLoading = true;
                API.updatePlanList({
                    account_id:this.formItem.account_id,
                }).then(res=>{
                    console.log('updatePlanList',res);
                    if(this.planNotifyTip){
                        this.planNotifyTip.close();
                        this.planNotifyTip = null;
                    }
                    this.updatePlanLoading = false;
                    this.getPlanList();
                    this.$notify.success({
                        title: '更新成功',
                        message: '计划列表更新成功',
                        duration: 1000*3
                    });
                },err=>{
                    if(this.planNotifyTip){
                        this.planNotifyTip.close();
                        this.planNotifyTip = null;
                    }

                    this.updatePlanLoading = false;
                    console.log('updatePlanList err',err);
                    this.$notify.error({
                        title: '更新失败',
                        message: err.info,
                        duration: 0
                    });
                })
            },
            checkPlanInfo(){
                this.checkPlanLoading = true;
                this.$refs.checkPlanModal.checkPlanInfo();
            },
            confirmPlanInfo(data){
                this.isCheckedPlanInfo = true;
                this.hasGroupTargetId = data.hasGroupTargetId;
                this.taskId = data.taskId;
                this.sourceAppId = data.appId;
                this.isAimedia = data.isAimedia

                /* 核实信息后，目标账户设置默认值 */
                let curAccount = this.accountList.find(item=>item.account_id==this.formItem.account_id);
                if(curAccount){
                    this.$nextTick(()=>{
                        this.targetAccountList = [utils.deepClone(curAccount)];
                        this.formItem.target_account = [this.formItem.account_id];
                    });
                }
                this.$refs.form1.validate('is_check_plan');
            },
            changeTargetAccount(val){
                console.log('changeTargetAccount',val);
                let maxLen = val && val.length
                if(maxLen > this.checkMax) {
                    return this.$message.warning(`目前最多支持选择${this.checkMax}个`)
                }
                this.formItem.target_account = val
                this.resetStep2Data();
            },
            getTargetAccountList(query){
                if(!query) return this.accountList = [];
                this.targetAccountLoading = true;
                API.getAccountList({
                    search:query,
                }).then(res=>{
                    let resList = res.data||[];
                    /* 数据量大时直接截取前100条 */
                    this.targetAccountList = resList.slice(0,100);
                    this.targetAccountLoading = false;
                },err=>{
                    console.log('getAccountList err',err);
                    this.targetAccountList = [];
                    this.targetAccountLoading = false;
                })
            },
            handleBatchAppClick(){
                console.log('handleBatchAppClick');
                batchEnterModal({
                    props: {
                        appList:this.appListCacheOptions,
                        ids: this.formItem.app_id
                    },
                    cbs: {
                        onSubmit:(list)=>{
                            console.log('onSubmit：保存',list);
                            list.forEach(item=>{
                                if(!this.formItem.app_id.includes(item.package_name)){
                                    this.formItem.app_id = [ ...(this.formItem.app_id || []),item.package_name ];
                                }
                            })
                            this.$nextTick(()=>{
                                this.$refs.form2.clearValidate(['app_id'])
                            })
                        },
                    }
                })
            },
            getAppList(){
                if(this.formItem.target_account.length<=0) return false;
                this.appLoading = true;
                API.getAppList({
                    app_id:this.sourceAppId,
                    target_account:this.formItem.target_account.join(','),
                    account_id:this.formItem.account_id,
                    plan_id:this.formItem.plan_id,
                    task_id:this.taskId,
                }).then(res=>{
                    console.log('getAppList',res);
                    this.appLoading = false;
                    let resData = res.data||[];
                    this.appListCacheOptions = (res.data||[]).map(item=>({res_label:`${item.app_name}${item.app_id}${item.package_name}'`, ...item}));
                    this.appList = resData

                    if(Array.isArray(this.formItem.app_id)&&this.formItem.app_id.length<=0){
                        let defaultApp = resData.find(item=>item.checked);
                        if(defaultApp){
                            this.$nextTick(()=>{
                                this.formItem.app_id = [defaultApp.package_name];
                            })
                        }else{
                            this.formItem.app_id = [];
                        }
                    }

                },err=>{
                    console.log('getAppList err',err);
                    this.appLoading = false;
                    this.appList = [];
                    this.appListCacheOptions = []
                    this.formItem.app_id = [];
                })
            },
            // 获取资质信息
            getQualification() {
                this.$notify.closeAll()

                this.qualificationLoading = true
                let app_list = []
                this.formItem.app_id.forEach(app=>{
                    let actionApp = this.appList.find(item=>item.package_name==app)||{};
                    app_list.push({app_id:actionApp.app_id, app_name:actionApp.app_name, package_name:actionApp.package_name}) ;
                });
                let params = {
                    task_id:this.taskId,
                    user_names:this.formItem.target_account.join(','),
                    app_list: app_list
                }
                API.postQualificationList(params).then(res=>{
                    this.formItem.qualificationStatus = true;
                    console.log(this.curAppData, 'curAppDatacurAppData');
                    const params = {
                        task_id: this.taskId,
                        app_list
                    }
                    API.getAppDefaultLink(params).then((res)=> {
                        this.linkConfigList = res.data;
                    });
                    if (this.deeplinkValidConfig.length <=0) {
                        API.getDeepLinkConfig().then((res)=> {
                            this.deeplinkValidConfig = res.data;
                        });
                    }
                    this.$nextTick(()=>{
                        this.$refs.form2.clearValidate(['qualificationStatus', 'linkConfigList'])
                    })

                },err=>{
                    this.formItem.qualificationStatus = false
                    let flag_single_post_html = ''

                    if(!err?.info) {
                        flag_single_post_html = `<div><div class="qualification_err_title">请联系产研，接口调用失败</div>
                        <div style="text-align: right;">
                            <button style="padding: 0; " class="el-button el-button--primary el-button--mini"><span class="apple-dialog-btn—close inline-block " style="padding: 7px 15px;" id="qualification_close">关闭</span></button>
                        </div>
                        </div>`
                        this.$notify.error({
                            customClass: 'customRed_notify',
                            showClose: false,
                            title: '资质认证接口调用失败',
                            dangerouslyUseHTMLString: true,
                            duration: 0,
                            message: flag_single_post_html
                        });
                        document.querySelector('#qualification_close').addEventListener('click',()=>{
                            this.$notify.closeAll()
                        })
                        return
                    }

                    this.formItem.qualificationStatus = false
                    let res_title = err.info.split('\\n')
                    
                    if(err.data.length === 0) {
                        flag_single_post_html = `<div><div class="qualification_err_title">${res_title[1]}</div>
                        <div style="text-align: right;">
                            <button style="padding: 0; " class="el-button el-button--primary el-button--mini"><span class="apple-dialog-btn—close inline-block " style="padding: 7px 15px;" id="qualification_close">关闭</span></button>
                        </div>
                        </div>`
                    }else {
                        let info = err.data && err.data.map(item=>{
                            let ul_title = `<div style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;" title=${item.app_name}(${item.app_id})(${item.package_name})>${item.app_name}(${item.app_id})(${item.package_name})</div>`
                            let li_title = item.err_account_list && item.err_account_list.map(item=>`<li style="padding-left: 24px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;" title=${JSON.stringify(item)}>${item}</li>`).join('')
                            return `${ul_title}${li_title}`
                        }).join('')
                        flag_single_post_html = `<div>
                            <div class="qualification_err_title">${res_title[1]}</div>
                            <div class='qualification_err_list' style="max-height:35vh;overflow-y:auto;text-align: left;font-size: 12px;max-width: 364px;">${info}</div>
                            <div style="text-align: right;">
                                <button style="padding: 0; " class="el-button el-button--primary el-button--mini"><span class="apple-dialog-btn—close inline-block " style="padding: 7px 15px;" id="qualification_close">关闭</span></button>
                            </div>
                            </div>`
                    }
                    this.$notify.error({
                        customClass: 'customRed_notify',
                        showClose: false,
                        title: res_title[0],
                        dangerouslyUseHTMLString: true,
                        duration: 0,
                        message: flag_single_post_html
                    });
                    document.querySelector('#qualification_close').addEventListener('click',()=>{
                        this.$notify.closeAll()
                    })
                }).finally(()=>{
                    this.qualificationLoading = false
                })
            },
            changeDateType(val){
                this.dateType = val;
            },
            getUploadConfig(){
                API.getUploadConfig({
                    plan_id:this.formItem.plan_id,
                    task_id:this.taskId,
                }).then(res=>{
                    let resData = res.data||[];
                    if(resData.length<=0) return this.$message.error('未获取到该计划下有效的创意数据');
                    this.planUploadConfig = resData||[];
                    let firstGroup = resData[0]||{};
                    this.activeGroupId = firstGroup.group_id||'';

                    let displayList = firstGroup.display_list||[];
                    let firstDisplay = displayList[0]||{};
                    this.activeDisplayId = firstDisplay.display_type||'';

                    let normList = firstDisplay.norm_list||[];
                    let firstNorm = normList[0]||{};
                    this.activeNormId = (firstNorm.norm_model+'-'+firstNorm.norm_id)||'';
                    this.filesTables = {};
                },err=>{
                    console.log('getUploadConfig err',err);
                })
            },
            changeGroupItem(groupId){
                if(this.uploadQueueCnt>0&&this.fullscreenLoading) return this.$message.error('文件正在上传中，请稍候再试');
                this.activeGroupId = groupId;

                let displayList = this.activeGroup.display_list||[];
                let firstDisplay = displayList[0]||{};
                this.activeDisplayId = (displayList[0]||{}).display_type||'';

                let normList = firstDisplay.norm_list||[];
                let firstNorm = normList[0]||{};
                this.activeNormId = (firstNorm.norm_model+'-'+firstNorm.norm_id)||'';
            },
            changeDisplayTypeItem(displayType){
                if(this.activeDisplayId == displayType) return;
                if(this.uploadQueueCnt>0&&this.fullscreenLoading) return this.$message.error('文件正在上传中，请稍候再试');
                this.activeDisplayId = displayType;
                let normList = this.activeDisplayType.norm_list||[];
                let firstNorm = normList[0]||{};
                this.activeNormId = (firstNorm.norm_model+'-'+firstNorm.norm_id)||'';
            },
            changeNormItem(norm){
                let normId = norm.norm_model+'-'+norm.norm_id;
                if(this.activeDisplayId == normId) return;
                if(this.uploadQueueCnt>0&&this.fullscreenLoading) return this.$message.error('文件正在上传中，请稍候再试');
                this.activeNormId = normId;
            },
            stopUploading(){
                console.log('stopUploading');
                this.$refs.upload.abort();
                this.fullscreenLoading = false;
            },
            // 上传loading
            handleProgress() {
                this.fullscreenLoading = true;
            },
            handleUpload(file){
                // if(file.name.includes('#')){
                //     this.$message.error('文件名中不可以有#');
                //     return false;
                // }

                let fileExt = (file.name.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)||[])[0];
                let fileConfigs = this.fileConfigs;
                let $message = this.$message;
                let _this = this;

                return new Promise((resolve,reject) => {
                    if(file.type.includes('image')){
                        let reader = new FileReader();
                        reader.onload = function (event) {
                            let img = document.createElement("img");
                            img.src = event.target.result;
                            img.onload = function () {
                                file.width = img.width;
                                file.height = img.height;
                                let fileInfo = {
                                    duration: null,
                                    height: img.height,
                                    width: img.width
                                };
                                let isAvailable  = fileConfigs.some(item=>{
                                    let {conf_format,conf_size,conf_resolution} = item;
                                    return conf_format.includes(fileExt.replace('.',''))&&file.size<+item.conf_size&&(fileInfo.width+'*'+fileInfo.height)==item.conf_resolution;
                                });
                                if(isAvailable){
                                    _this.uploadQueueCnt++;
                                    resolve();
                                }else{
                                    $message.error('素材不匹配：'+file.name);
                                    reject();
                                }
                            }
                        };
                        reader.readAsDataURL(file);

                    }else if(file.type.includes('video')){
                        let reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = function (event) {
                            const videoElement = document.createElement("video");
                            videoElement.src = event.target.result;
                            videoElement.addEventListener("loadedmetadata", function () {
                                let fileInfo = {
                                    duration: videoElement.duration,
                                    height: videoElement.videoHeight,
                                    width: videoElement.videoWidth
                                };
                                let isAvailable  = fileConfigs.some(item=>{
                                    let {conf_format,conf_size,conf_resolution} = item;
                                    let [configWithd,configHeight] = item.conf_resolution.split('*');
                                    /* 宽高在误差内都通过 */
                                    let diffVal = 2;    // 误差值
                                    let isMatchWidth = fileInfo.width<+configWithd+diffVal&&fileInfo.width>+configWithd-diffVal;
                                    let isMatchHeight = fileInfo.height<+configHeight+diffVal&&fileInfo.height>+configHeight-diffVal;
                                    return conf_format.includes(fileExt.replace('.',''))&&file.size<+item.conf_size&&(isMatchWidth&&isMatchHeight);
                                });
                                if(isAvailable){
                                    _this.uploadQueueCnt++;
                                    resolve();
                                }else{
                                    $message.error('素材不匹配：'+file.name);
                                    reject();
                                }
                            });
                        };
                    }
                });
            },
            handleSuccess(res){
                this.fullscreenLoading = false;
                this.uploadQueueCnt--;
                if(res.code==200){
                    let fileData = res.data||{};
                    /* 上传成功后缓存上传的文件 */
                    let file = this.uploadStore.find(item=>item.md5==fileData.md5);
                    if(!file){
                        this.uploadStore.push(fileData);
                    }
                    let fileResolute = fileData.width+'*'+fileData.height;
                    let configs = this.fileConfigs.find(item=>item.conf_format.includes(fileData.ext)&&+item.conf_size>fileData.size&&item.conf_resolution==fileResolute);
                    if(!configs) return this.$message.error('未匹配到相应格式');
                    this.addMaterialToTable(fileData,this.uploadSign,configs.value_name);
                    this.updateTotalNum();
                }else{
                    this.$notify.error({
                        title: '上传失败',
                        message: res.info,
                        duration: 0
                    });
                }
            },
            handleError(error, file, fileList){
                console.log('handleError',error, file,fileList);
                this.$message.error('文件上传失败：',file.name);
                this.uploadQueueCnt--;
                this.fullscreenLoading = false;
            },
            copyMaterial(file,colName){
                let fileData = this.uploadStore.find(item=>item.md5==file.md5);
                this.addMaterialToTable(fileData,this.uploadSign,colName);
                this.updateTotalNum();
            },
            removeMaterial(rowIndex,colName){
                let curTableData = this.filesTables[this.uploadSign];
                let curRow = curTableData[rowIndex];
                this.$set(curRow,colName,null);
                this.updateTotalNum();

                let isNullRow = Object.values(curRow).every(item=>item===null);

                if(isNullRow&&rowIndex==this.filesTables[this.uploadSign].length-1){
                    this.filesTables[this.uploadSign].splice(rowIndex,1);
                }
            },
            addMaterialToTable(fileData,uploadSign,colName){
                /* 素材，表格ID,列名  */
                let curTableData = this.filesTables[uploadSign];
                if(!curTableData){
                    this.$set(this.filesTables,uploadSign,[]);
                    curTableData = this.filesTables[uploadSign];
                }
                if(curTableData.length<=0){
                    let rowData = {};
                    this.$set(rowData,colName,{
                        material_src:fileData.fullFilePath,
                        material_url:fileData.filePath,
                        material_name:fileData.name,
                        md5:fileData.md5,
                    });
                    curTableData.push(rowData);
                }else{
                    let targetRow = curTableData.find(item=>!item[colName]);
                    if(targetRow){
                        this.$set(targetRow,colName,{
                            material_src:fileData.fullFilePath,
                            material_url:fileData.filePath,
                            material_name:fileData.name,
                            md5:fileData.md5,
                        });
                    }else{
                        let rowData = {};
                        this.$set(rowData,colName,{
                            material_src:fileData.fullFilePath,
                            material_url:fileData.filePath,
                            material_name:fileData.name,
                            md5:fileData.md5,
                        });
                        curTableData.push(rowData);
                    }
                }
            },
            updateTotalNum(){
                let actionGroup = this.planUploadConfig.find(item=>item.group_id == this.activeGroupId);
                let actionDisplayType = (actionGroup.display_list||[]).find(item=>item.display_type==this.activeDisplayId);
                let actionNorm = (actionDisplayType.norm_list||[]).find(item=>item.norm_model+'-'+item.norm_id==this.activeNormId);
                let requiredCols = this.fileConfigs.filter(item=>item.material_is_null=='0').map(item=>item.value_name);
                let useful = this.filesTables[this.uploadSign].filter(item=>{
                    return requiredCols.every(inner=>!!item[inner])
                });
                this.$set(actionNorm,'total',useful.length);
                this.$set(actionDisplayType,'total',(actionDisplayType.norm_list||[]).map(item=>item.total||0).reduce((a,b)=>a+b));
                this.$set(actionGroup,'total',(actionGroup.display_list||[]).map(item=>item.total||0).reduce((a,b)=>a+b));
            },
            taskPreviewInfo(){
                API.taskPreviewInfo({
                    task_id:this.taskId,
                }).then(res=>{
                    console.log('taskPreviewInfo',res);
                },err=>{
                    console.log('taskPreviewInfo err',err);
                })
            },
            taskPreviewIdeaList(){
                API.taskPreviewIdeaList({
                    task_id:this.taskId,
                }).then(res=>{
                    console.log('taskPreviewIdeaList',res);
                },err=>{
                    console.log('taskPreviewIdeaList err',err);
                })
            },
            handleSubmit(){
                this.submitLoading = true;
                API.saveTask({
                    task_id:this.taskId,
                    plan_status:this.formItem.plan_status,
                    general_switch:this.formItem.general_switch,
                    skip_ocpx_stage:this.formItem.skip_ocpx_stage,
                    group_start_date:this.dateType=='1'?utils.formatDate(this.range):utils.formatDate(this.range1[0]),
                    group_end_date:this.dateType=='1'?'2038-01-19':utils.formatDate(this.range1[1]),
                    idea_upload_config:this.formItem.idea_upload_config,
                }).then(res=>{
                    this.submitLoading = false;
                    this.$message.success(res.info||'');

                    this.toListPage();
                    this.$emit('update');
                },err=>{
                    console.log('handleSubmit err',err);
                    this.submitLoading = false;
                    this.$notify.error({
                        title: '提交失败',
                        message: err.info,
                        duration: 0
                    });
                })
            },
            getGroupvalidata() {
                let isequel = true;
                let totalData = {};
                let initTotalData = {};
                this.$bus.$emit('getTotalNum', (total, initData,  applist)=> {
                    totalData = total;
                    initTotalData = initData;
                    const errList = [];
                    const package_name_list =
                    applist.map(v=> {
                        const package_name = v.package_name;
                        if (!total[package_name]) {
                            errList.push(v.app_name)
                        };
                        return package_name;
                    });
                    if (errList.length) {
                         isequel = false;
                        tipModal({
                            props: {
                                tip: '以下产品素材为空，请检查！',
                                list: {
                                    "": errList
                                }
                            }
                        })
                        // this.$message.error(`产品${errList.join(',')}为上传素材`)
                    }else {
                        const deep = package_name_list.every(appId=>totalData[appId] === initTotalData[appId]);
                        console.log('---sc',totalData, initTotalData, deep)
                        console.log('---scb',applist)
                        if (deep) {
                            isequel = true
                        }else {
                            this.$message.error('素材存在必填项，请检查')
                            isequel = false
                        }
                    }
                });
                if(isequel) {
                    return isequel
                }
                return isequel
            },
            async validataAimediaData() {
                try {
                    return await this.$refs.aiLaunchIdeaRef.validateFn()
                } catch (error) {
                    if(Array.isArray(error)) {
                        this.popoverVisible = true;
                        this.errorFormList = error;
                    }
                    return false
                }
            },
            previewIdeaDom() {
                const isequal = this.getGroupvalidata()
                if(!isequal) return
                this.previewLoading = true;
                const params = this.$refs.UploadIdea.getParamsData();
                this.$refs.ideaSpecsPreview.preview(params)
            },
            async previewIdeaInfo(){
                let params = null;
                if(!this.isAimedia) {
                    const isequal = this.getGroupvalidata()
                    if(!isequal) return
                    params = this.$refs.UploadIdea.getParamsData();
                }else {
                    const data = await this.validataAimediaData();
                    console.log(data, 'datadatadatadata');
                   
                    if(!data) return;
                    params = data;
                }
                if(this.isAimedia) {
                    // 智能投放
                    this.aiPreview(params)
                    return
                }
                this.previewLoading = true;
                this.$refs.ideaSpecsPreview.preview(params,  this.linkConfigData).then((resData)=>{
                    this.previewLoading = false;
                    let createNum = resData.create_num||[];
                    // let totalNum = createNum.length>0?createNum.map(item=>+item.num||0).reduce((a,b)=>a+b):0;
                    if(createNum.length>0){
                        let htmlStr = `<div style="max-height: 250px;overflow: auto;"><p>以下目标账户今日新建广告加上此次需要创建的广告数量已经 <span class="text-color-error">超过500条</span>，请确认是否有权限可继续创建，以免造成重复工作！</p>`;

                        createNum.forEach(item=>{
                            htmlStr += `<p class="font12px clear-both"> <span class="fl">${item.name}</span> <span class="fr text-color-error">${item.num}条</span> </p>`;
                        });
                        htmlStr += `</div>`;
                        this.$confirm(htmlStr,'提示',{
                            confirmButtonText: '可继续创建',
                            cancelButtonText: '关闭提示',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            this.curStep++;
                            this.$refs.ideaList.getIdeaInfo();
                        }).catch(()=>{
                            console.log('取消');
                        })
                    }else{
                        this.curStep++;
                        this.$refs.ideaList.getIdeaInfo();
                    }
                },()=>{
                    this.previewLoading = false;
                })
            },
            async aiPreview(material) {
                try {
                    this.previewLoading = true;
                    const params = {
                        target_account:this.formItem.target_account.join(','),
                        task_id:this.taskId,
                        package_name:(this.curAppData||[]).map(item=>item.package_name),
                        smart_product_material_pkg: material,
                        replace_name_status:this.formItem.replace_name_status,
                        app_link_info: this.linkConfigData,
                    }
                    const resData = await API.taskAiPreview(params);
                    let createNum = resData.create_num||[];
                    // let totalNum = createNum.length>0?createNum.map(item=>+item.num||0).reduce((a,b)=>a+b):0;
                    if(createNum.length>0){
                        let htmlStr = `<div style="max-height: 250px;overflow: auto;"><p>以下目标账户今日新建广告加上此次需要创建的广告数量已经 <span class="text-color-error">超过500条</span>，请确认是否有权限可继续创建，以免造成重复工作！</p>`;

                        createNum.forEach(item=>{
                            htmlStr += `<p class="font12px clear-both"> <span class="fl">${item.name}</span> <span class="fr text-color-error">${item.num}条</span> </p>`;
                        });
                        htmlStr += `</div>`;
                        this.$confirm(htmlStr,'提示',{
                            confirmButtonText: '可继续创建',
                            cancelButtonText: '关闭提示',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            this.curStep++;
                            this.$refs.ideaList.getIdeaInfo();
                        }).catch(()=>{
                            console.log('取消');
                        })
                    }else{
                        this.curStep++;
                        this.$refs.ideaList.getIdeaInfo();
                    }
                } catch (error) {
                    const data = error.data; 
                    if( data && data.length > 0 ){
                        /**
                         *  {
                        title: '每个产品最少需要拥有一个标题，并且符合输入要求，请检查',
                        list: errTitleList
                    },
                         */
                        this.popoverVisible = true;
                        this.errorFormList =  data.map(v=> {
                            return  {
                                title: v.err_msg,
                                list: v.err_list
                            }
                        });;
                     }else {
                        this.$message.error(error.info);
                     }
                }finally {
                    this.previewLoading = false;
                }
            },
            updatePreviewLoading(val){
                this.previewLoading = val;
            },
            cancelCreate(){
                if(this.curStep == 1&&!this.formItem.account_id){
                    this.toListPage();
                }else{
                    this.$confirm('取消后不会保存当前内容，确认要取消吗？','温馨提示',{
                        confirmButtonText: '确认取消',
                        cancelButtonText: '关闭',
                        type: 'warning',
                    }).then(()=>{
                        this.toListPage();
                    })
                }
            },
            toListPage(){
                this.$emit('changePage','list');
                this.resetForm();
            },
            resetStep2Data(){
                this.formItem.app_id = [];
                this.linkConfigList = []
            },
            resetStep3Data(){
                this.uploadQueueCnt = 0;
                this.uploadStore = [];
                this.filesTables[this.uploadSign] = [];
                this.filesTables = {};
                this.planUploadConfig = [];
            },
            toLastStep(){
                if(this.curStep==4){
                    this.$confirm('如果已经手动修改了内容，不会保留，下次生成预览时需要再次修改，请知晓！','温馨提示',{
                        confirmButtonText: '确认',
                        cancelButtonText: '关闭',
                        type: 'warning',
                    }).then(()=>{
                        this.curStep--;
                    })

                }else{
                    this.curStep--;
                }

            },

            confirmCheckBudget(){
                return new Promise((resolve, reject)=>{
                    /* 判断预算逻辑 */
                    this.nextStepLoading = true;
                    API.checkBudget({
                        task_id:this.taskId,
                        target_account:this.formItem.target_account.join(',')
                    }).then(res=>{
                        console.log('checkBudget',res);
                        this.nextStepLoading = false;
                        resolve();
                    },err=>{
                        console.log('checkBudget err',err);
                        this.nextStepLoading = false;
                        let errData = err.data||{};
                        let budgetData = errData.budget||[];
                        let createNum = errData.create_num||[];
                        if(budgetData.length>0){
                            let htmlStr = `<div style="max-height: 250px;overflow: auto;">`;
                            budgetData.forEach(item=>{
                                htmlStr += `<p class="text-color-error font12px">${item.info}</p><p class="pl10 font12px">${item.current}</p><p class="pl10 font12px" style="margin-bottom: 15px;">${item.target}</p>`;
                            });
                            htmlStr += `</div>`;
                            this.$alert(htmlStr, '', {
                                confirmButtonText: '关闭',
                                dangerouslyUseHTMLString: true,
                                customClass:'wide-confirm-box-550',
                                type: 'error',
                            });
                            // resolve();
                            reject();
                        }else{
                            if(createNum.length>0){
                                let htmlStr = `<div style="max-height: 250px;overflow: auto;"><p>以下目标账户今日新建广告已经 <span class="text-color-error">超过490条</span>，请确认是否有权限可继续创建，以免造成重复工作！</p>`;
                                createNum.forEach(item=>{
                                    htmlStr += `<p class="font12px">${item.name}</p>`;
                                });
                                htmlStr += `</div>`;
                                this.$confirm(htmlStr,'提示',{
                                    confirmButtonText: '可继续创建',
                                    cancelButtonText: '取消创建',
                                    type: 'warning',
                                    dangerouslyUseHTMLString: true,
                                    customClass:'wide-confirm-box-550',
                                }).then(()=>{
                                    console.log('继续');
                                    resolve()
                                }).catch(()=>{
                                    console.log('取消');
                                    reject();
                                })
                            }else{
                                resolve();
                            }
                        }
                    });
                })
            },
            toNextStep(){
                if(this.curStep==1){
                    this.$refs.form1.validate((valid) => {
                        if (valid) {
                            this.confirmCheckBudget().then(()=>{
                                this.curStep++;
                                this.formItem.batch_rules = this.pageFuncNames.includes('create_config_1')?'1':'';
                                this.getAppList();
                            },()=>{
                                console.log('不创建了');
                            })

                        } else {
                            console.log('error next!!');
                            return false;
                        }
                    });
                }else if(this.curStep==2){
                    Promise.all([this.$refs.form2.validate(), this.$refs.linkConfigRef? this.$refs.linkConfigRef.validate() : Promise.reject()]).then(([,linkConfigData])=>{
                        this.curStep++;
                        this.linkConfigData = linkConfigData.map((item)=> {
                            const { b_address, c_address, deeplink , package_name } = item;
                            return {
                                package_name,
                                view_monitor_url: b_address,
                                click_monitor_url: c_address,
                                deeplink
                            }
                        });
                        console.log(this.linkConfigData, 'linkConfigDatalinkConfigData');
                    }).catch(()=> {})
                   
                }else{
                    this.curStep++;
                }
            },
            handleIdeaShow() {
                this.$refs.ideaSpecsPreview.getSourcePlanConfig();
            },
            // 全选操作相关逻辑
            handleVisible(value) {
                if(!value) {
                    this.appList = []
                    this.appList = this.appListCacheOptions
                }
            },
            SearchFilter(val) {
                this.appList = this.appListCacheOptions.filter(item=> {
                        return item.res_label.toLowerCase().indexOf(val.toLowerCase()) > -1
                    }
                )
            },
            handleAllSelect(type) {
                if(type == 'all') {
                    let append = this.appListCacheOptions.map(item=>item.package_name)
                    let cur_list = uniq([...this.formItem.app_id, ...append])
                    let maxLen = cur_list.length
                    if(maxLen > this.checkMax) {
                        return this.$message.warning(`目前最多支持选择${this.checkMax}个`)
                    }
                    this.formItem.app_id = cur_list
                }else{
                    let optionList_ids = this.appListCacheOptions.map(item=>item.package_name)
                    let channel_ids = this.formItem.app_id.filter(item=> !optionList_ids.includes(item))
                    this.formItem.app_id = [...channel_ids]
                }
                this.$refs['productRef'].blur()
            },
            handleChange(value) {
                let maxLen = value && value.length
                if(maxLen > this.checkMax) {
                    return this.$message.warning(`目前最多支持选择${this.checkMax}个`)
                }
                this.formItem.app_id = value
                this.linkConfigList = remove(this.linkConfigList, (v)=> {
                    return value.includes(v.package_name)
                })
            },
        },

        beforeDestroy() {
            window.onbeforeunload = null;
        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .el-step__title{
        font-size: 12px;
    }
    .title-group{
        font-size: 14px;
        margin-bottom: 20px;
    }
    .action-btn{
        width: 120px;
        margin: 0 20px;
    }
    .tab-nav-btn{
        width: 150px;
    }
    .ad-group-items{
        display: flex;
        flex-wrap: wrap;
        line-height: 16px;
    }

    .material-content-wrap{
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        min-height: 500px;
        .left-con{
            max-width: 1200px;
            height: 100%;
            margin-right: 20px;
            width: calc(100% - 350px);
        }

        .right-con{
            height: 100%;
            width: 330px;
            padding: 15px 10px;
            border-radius: 5px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            background-color: #f2f2f2;
            border:1px solid #d7d7d7;
            flex: 1;
        }
    }

    // ::v-deep .upload-box .el-upload {
    //     width: 100%;
    //     .el-upload-dragger{
    //         width: 100%;
    //         height: 80px;
    //         .el-icon-upload{
    //             font-size: 40px;
    //             margin: 0 auto;
    //             line-height: 40px;
    //             color: #409EFF;
    //         }
    //         .el-upload__text{
    //             font-size: 12px;
    //         }
    //     }
    // }

    // .upload-box .upload-loading-wrap{
    //     position: absolute;
    //     z-index: 2;
    //     right: 20px;
    //     top: 10px;
    //     cursor: pointer;
    //     color: #409EFF;
    //     .el-icon-loading{
    //         font-size: 30px;
    //     }
    // }
    .stop-upload-wrap{
        position: absolute;
        right: 10px;
        top: 45px;
    }

    .material-table-wrap{
        border: solid 1px #ccc;
        h3{
            border-bottom: solid 1px #ccc;
        }
        .table-header-self p{
            line-height: 12px;
            font-weight: normal;
        }
        ::v-deep .el-table__header .el-table__cell{
            padding: 3px 0;
        }

    }
    .img-holder{
        height: 80px;
        width: 100%;
        background: #eee;
        border: dashed 1px #ccc;
    }

    .mini-switch{
        transform: scale(0.8);
    }

    .input-width {
        width: 600px;
    }

    .create_page_header{
        border-top: solid 10px #efefef;
        background-color: #fff;
        padding: 4px 8px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        position: fixed;
        top: 50px;
        z-index: 30;
        box-shadow: 0 1px 2px #d9d9d9;
        .text {
            display:inline-block;
            line-height: 32px;
        }
    }

    .create_page_body{
        margin-top: 42px;
        background-color: #fff;
        min-height:  calc(100vh - 135px);
        padding-bottom: 50px;
    }
    .step-bar{
        padding-top: 40px;
    }

</style>
<style lang="scss">
.customRed_notify{
    &.el-notification{
        width: 430px;
        min-width: 430px;
    }
    .el-notification__title{
        color: #ff0000;
    }
    .qualification_err_title{
        color: #ff0000;
    }
}
</style>
